import { api, ENDPOINTS } from './api';
import type { Notification, PagedResult, PaginationParams } from '@/types';

export const notificationService = {
  async list(params?: PaginationParams): Promise<PagedResult<Notification>> {
    const { data } = await api.get<PagedResult<Notification>>(ENDPOINTS.notifications.list, {
      params,
    });
    return data;
  },
  async markRead(id: string): Promise<void> {
    await api.post(ENDPOINTS.notifications.markRead(id));
  },
  async markAllRead(): Promise<void> {
    await api.post(ENDPOINTS.notifications.markAllRead);
  },
};
